import {
  Button,
  Col,
  Drawer,
  Form,
  Input,
  Row,
  Select,
  Space,
  Spin
} from "antd";
import { Component } from "react";
import "../styles/general.css";

import { GET, POST } from "../constants/request-type";
import {
  city,
  get_all_city,
  get_all_province,
  // update_password_user
  province
} from "../constants/routes";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { decryptSingleData } from "../functions/cryptojs";
import { openNotificationWithIcon } from "../functions/notification";
import { uploadFile } from "../functions/upload-file";
import { EmailValidation } from "../functions/validateEmailPassword";

import logger from '../../utils/logger.js';
const token = sessionStorage.getItem("auth_token");

const { Option } = Select;

class Partner_new extends Component {
  state = {
    visible: false,
    company_name: "",
    owner_name: "",
    email: "",
    number: "",
    comission: null,
    comission_delivery: null,
    tax: 0,
    password: "",
    c_password: "",
    province: "",
    city: "",
    list: [],
    list2: [],
    province_list: [],
    city_list: [],
    pic: null,
    load: false
  };

  componentDidMount() {
    this.getData();
  }
  handleChange = (e) => {
    e.preventDefault();
    this.setState({ [e.target.name]: e.target.value });
  };
  handleImage = (e) => {
    e.preventDefault();
    return this.setState({ pic: e.target.files[0] });
  };
  getData = async () => {
    const request_details_province = {
      type: GET,
      url: service_api,
      route: province + "/" + get_all_province,
      data: null,
      token: token
    };

    const request_details_city = {
      type: GET,
      url: service_api,
      route: city + "/" + get_all_city,
      data: null,
      token: token
    };

    try {
      const [response_province, response_city] = await Promise.all([
        MakeRequestAsync(request_details_province),
        MakeRequestAsync(request_details_city)
      ]);

      this.setState({
        province_list: decryptSingleData(response_province?.data?.province),
        city_list: decryptSingleData(response_city?.data?.city),
        load: false
      });
    } catch (err) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        `${err?.response?.data?.message}`
      );
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    const {
      company_name,
      owner_name,
      email,
      comission,
      comission_delivery,
      tax,
      number,
      password,
      c_password,
      pic,
      province,
      city
    } = this.state;

    const data = {
      company_name,
      owner_name,
      email,
      comission,
      comission_delivery,
      tax,
      number,
      password,
      c_password,
      pic,
      province,
      city
    };

    if (company_name === "" || owner_name === "" || number === "") {
      return openNotificationWithIcon(
        "error",
        "Vous devez remplir tout les champs"
      );
    }

    if (!EmailValidation(email)) {
      return openNotificationWithIcon("error", "L'adresse mail est invalide");
    }

    if (comission < 0 || comission_delivery < 0) {
      return openNotificationWithIcon(
        "error",
        "Les comissions ne peuvent être en dessous de 0"
      );
    }

    if (province.length === 0 || city.length === 0) {
      return openNotificationWithIcon(
        "error",
        "Vous devez fournir les informations relatives à la province et ville"
      );
    }

    if (password !== c_password) {
      return openNotificationWithIcon(
        "error",
        "Les mots de passe ne sont pas identiques"
      );
    }

    this.setState({ load: true });

    let pic_url;

    pic_url = await uploadFile(pic);

    if (!pic_url.data.success) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        "Une erreur est survenue lors de l'upload de la photo"
      );
    }

    const request_details = {
      type: POST,
      url: service_api,
      route: "glocery-partner/create-glocery-partner",
      data: {
        ...data,
        country_code: "+1",
        pic: pic_url.data.url
      },
      token: token
    };

    try {
      await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 0);
    } catch (err) {
      logger.log(err);
      this.setState({ load: false });
      return openNotificationWithIcon("error", err);
    }
  };

  showDrawer = () => {
    this.setState({
      visible: true
    });
  };

  onClose = () => {
    this.setState({
      visible: false
    });
  };

  render() {
    const {
      company_name,
      owner_name,
      email,
      comission,
      comission_delivery,
      number,
      password,
      c_password,
      pic,
      province,
      city,
      province_list,
      city_list,
      load
    } = this.state;
    return (
      <>
        <Button type="primary" onClick={this.showDrawer}>
          + Ajouter partenaire
        </Button>
        <Drawer
          title="Ajouter un partenaire"
          width={720}
          onClose={this.onClose}
          visible={this.state.visible}
          bodyStyle={{ paddingBottom: 80 }}
          footer={
            <div
              style={{
                textAlign: "right"
              }}
            >
              {load ? (
                <Space size="middle">
                  <Spin size="large" />
                </Space>
              ) : (
                <div>
                  <Button onClick={this.onClose} style={{ marginRight: 8 }}>
                    Retour
                  </Button>
                  <Button
                    onClick={(e) => {
                      this.handleSubmit(e);
                    }}
                    type="primary"
                  >
                    Soumettre
                  </Button>
                </div>
              )}
            </div>
          }
        >
          <Form layout="vertical" hideRequiredMark>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  label="Contact"
                  rules={[
                    {
                      required: true,
                      role: "Veuillez entrer le contact du partenaire"
                    }
                  ]}
                >
                  <Input
                    name="number"
                    
                    placeholder="Veuillez entrer le contact"
                    onChange={this.handleChange}
                    value={number}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="Nom de l'épicerie"
                  rules={[
                    {
                      required: true,
                      role: "Veuillez le nom de l'epicerie"
                    }
                  ]}
                >
                  <Input
                    name="company_name"
                    placeholder="Veuillez entrer le nom de l'épicerie"
                    onChange={this.handleChange}
                    value={company_name}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Nom propriétaire"
                  rules={[
                    {
                      required: true,
                      role: "Veuillez entrer le nom du propriétaire"
                    }
                  ]}
                >
                  <Input
                    name="owner_name"
                    placeholder="Veuillez entrer le nom du propriétaire"
                    onChange={this.handleChange}
                    value={owner_name}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Email"
                  rules={[
                    {
                      required: true,
                      role: "Veuillez votre l'email"
                    }
                  ]}
                >
                  <Input
                    name="email"
                    placeholder="Veuillez entrer l'email"
                    onChange={this.handleChange}
                    value={email}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Comission"
                  rules={[
                    {
                      required: true,
                      role: "Veuillez votre la comission"
                    }
                  ]}
                >
                  <Input
                    name="comission"
                    type="number"
                    placeholder="Veuillez entrer la comission"
                    onChange={this.handleChange}
                    value={comission}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Comission sur livraison"
                  rules={[
                    {
                      required: true,
                      role: "Veuillez votre la comission"
                    }
                  ]}
                >
                  <Input
                    name="comission_delivery"
                    type="number"
                    placeholder="Veuillez entrer la comission sur livraison"
                    onChange={this.handleChange}
                    value={comission_delivery}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="password"
                  label="Mot de passe"
                  rules={[
                    {
                      required: true,
                      role: "Veuillez entrer le mot de passe"
                    }
                  ]}
                >
                  <Input
                    name="password"
                    type="password"
                    placeholder="Veuillez entrer un mot de passe"
                    onChange={this.handleChange}
                    value={password}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="c_password"
                  label="Confirmer Mot de passe"
                  rules={[
                    {
                      required: true,
                      role: "Veuillez confimer le mot de passe"
                    }
                  ]}
                >
                  <Input
                    name="c_password"
                    type="password"
                    placeholder="Veuillez confirmer le mot de passe"
                    onChange={this.handleChange}
                    value={c_password}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="icon"
                  label="Icon"
                  rules={[
                    {
                      required: true,
                      message: "Upload is required"
                    }
                  ]}
                >
                  <Input
                    type="file"
                    accept="image/x-png,image/jpeg,image/jpg"
                    placeholder="Upload picture"
                    onChange={this.handleImage}
                    value={pic}
                    name="pic"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  label="Province"
                  rules={[
                    {
                      required: true,
                      role: "province"
                    }
                  ]}
                >
                  <Select
                    allowClear
                    style={{ width: "100%" }}
                    placeholder="Province"
                    defaultValue={province}
                    onChange={(data) => {
                      return this.setState({ province: data });
                    }}
                  >
                    {province_list.map((item) => (
                      <Option key={item?.province}>
                        <span>{item?.province}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  label="Ville"
                  rules={[
                    {
                      required: true,
                      role: "Ville"
                    }
                  ]}
                >
                  <Select
                    allowClear
                    style={{ width: "100%" }}
                    placeholder="Ville"
                    defaultValue={city}
                    onChange={(data) => {
                      return this.setState({ city: data });
                    }}
                  >
                    {city_list
                      ?.filter((item) => {
                        return item.province.province === province;
                      })
                      .map((item) => (
                        <Option key={item?.city}>
                          <span>{item?.city}</span>
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Drawer>
      </>
    );
  }
}

export default Partner_new;
